export default __webpack_public_path__ + "static/media/sign_up.2ef5b122.png";